import ContentParameterConfigDefaults from 'features/content-parameter-config-defaults/ContentParameterConfigDefaults';
import { ROLE_TYPE } from 'hooks/roles/types';
import useRequireRoles from 'hooks/roles/useRequireRoles';
import SiteConfigPage from 'pages/site-config/shared/SiteConfigPage';

function SiteConfigContentPresentationConfigDefaults() {
  useRequireRoles(ROLE_TYPE.ADMIN, ROLE_TYPE.SUPER);

  return (
    <SiteConfigPage title="Default Content Parameters">
      <ContentParameterConfigDefaults />
    </SiteConfigPage>
  );
}

export default SiteConfigContentPresentationConfigDefaults;
